// 터치 HUD의 환생 추가 칸(7번째 스킬 칸, 레인 R): 자동·고객 배치가 끝난 뒤 빈 자리를 고른다. 기존 6칸 배치는 바꾸지 않는다.
// 후보: 쪽 표시 왼쪽 → 쪽 표시 위 → 물약 위 → 스킬 6 위. 고정 영역(조이스틱 입력·상단 띠·게이지·고정 HUD)과 다른 칸에 겹치지 않는 첫 자리. 없으면 null(칸을 숨긴다)
import { hudRectsOverlap, touchCustomReserved, TOUCH_CUSTOM_IDS, touchRectOf, type HudInsets, type HudRect } from './skillHudLayout';

type Layout = Parameters<typeof touchRectOf>[0];
const GAP = 10;

export function seventhTouchRect(p: Layout, w: number, h: number, safe: HudInsets, fixed: readonly HudRect[] = []): HudRect | null {
  const d = p.size;
  const cands: HudRect[] = [
    { x: p.page.x - d - GAP, y: p.page.y, w: d, h: d },
    { x: p.page.x, y: p.page.y - d - GAP, w: d, h: d },
    { x: p.potions[0].x, y: p.potions[0].y - d - GAP, w: d, h: d },
    { x: p.skills[5].x, y: p.skills[5].y - d - GAP, w: d, h: d },
  ];
  const reserved = touchCustomReserved(p, w, h, safe, fixed);
  for (const c of cands) {
    if (c.x < safe.left || c.y < safe.top || c.x + c.w > w - safe.right || c.y + c.h > h - safe.bottom) continue;
    if (reserved.some((z) => hudRectsOverlap(c, z))) continue;
    if (TOUCH_CUSTOM_IDS.some((id) => hudRectsOverlap(c, touchRectOf(p, id)))) continue;
    if (hudRectsOverlap(c, p.attack)) continue;
    return c;
  }
  return null;
}
